import classnames from 'classnames/bind'

import AbstractLayoutSwitcher, {
  LayoutSwitcherProps as AbstractLayoutSwitcherProps,
} from '~/components/Abstracts/LayoutSwitcher'

import css from './styles.module.scss'

export type { LayoutSwitcherProps } from '~/components/Abstracts/LayoutSwitcher'

const cx = classnames.bind(css)

function LayoutSwitcher({ className, ...rest }: AbstractLayoutSwitcherProps) {
  return (
    <AbstractLayoutSwitcher
      className={cx(css.LayoutSwitcher, className)}
      {...rest}
    />
  )
}

LayoutSwitcher.defaultProps = {}

export default LayoutSwitcher
